import React from "react";
import { Checkbox, Form } from "semantic-ui-react";
// eslint-disable-next-line no-restricted-imports
import { useFormContext, Controller } from "react-hook-form";
import { fileSizeValidator, fileTypeValidator } from "../../../app/helpers/validators";
import AppForm from "../../../components/form/Form";
import { IApplicationForm } from "../types";

interface Props {
  companyName: string;
  companyCode: string;
}

const ApplicationForm = ({ companyName, companyCode }: Props) => {
  const { control } = useFormContext<IApplicationForm>();

  const consentLabel = (
    <label style={{ cursor: "pointer" }}>
      Sutinku, kad {companyName}, juridinio asmens kodas {companyCode}, fotografuotų ir (ar) filmuotų mane (arba mano
      atstovaujamą nepilnametį) LJA Šešėliavimo programos metu ir naudotų nuotraukas bei vaizdo įrašus, kuriuose matomas
      mano (arba mano atstovaujamo nepilnamečio) atvaizdas, {companyName} veiklos viešinimo tikslais – interneto
      svetainėje, „Facebook&rdquo;, „Instagram&rdquo;, „LinkedIn&rdquo; paskyrose ir spaudoje.
      <br />
      <br />
      Esu informuotas (-a), kad šis sutikimas yra savanoriškas, jo nedavimas neturi įtakos dalyvavimui LJA Šešėliavimo
      programoje, o duotą sutikimą galiu bet kada atšaukti kreipdamasis (-asi) į {companyName}.
    </label>
  );

  return (
    <>
      <AppForm.Group name="motivationLetter" label="application.form.motivation_letter">
        <AppForm.TextArea
          name="motivationLetter"
          placeholder="application.form.placeholder.motivation_letter"
          rules={{ required: true }}
        />
      </AppForm.Group>
      <AppForm.Group name="linkedinUrl" label="application.form.linkedin">
        <AppForm.Url name="linkedinUrl" placeholder="application.form.placeholder.linkedin" />
      </AppForm.Group>
      <AppForm.Group name="cv">
        <AppForm.File
          name="cv"
          placeholder="application.modal.attach_cv"
          accept={[".pdf", ".doc", ".docx"]}
          rules={{
            validate: {
              filesize: (v) => fileSizeValidator()(v),
              filetype: (v) => fileTypeValidator(["pdf", "doc", "docx"])(v),
            },
          }}
        />
      </AppForm.Group>
      <Form.Field style={{ marginTop: "1em" }}>
        <Controller
          name="allowPhotos"
          control={control}
          render={({ field }) => (
            <Checkbox
              label={consentLabel}
              checked={field.value}
              onChange={(_, data) => field.onChange(data.checked ?? false)}
            />
          )}
        />
      </Form.Field>
    </>
  );
};

export default ApplicationForm;
